import React, { createContext, useState } from "react";
export const TextEditorContext = /*#__PURE__*/createContext();
export const TextEditorConsumer = TextEditorContext.Consumer;
export const TextEditorProvider = ({
  children
}) => {
  const [editorFocus, setEditorFocus] = useState(false);
  const [textSelected, setTextSelected] = useState(false); // link modal

  const [linkModal, setLinkModal] = useState({
    open: false
  });
  const [currentLink, setCurrentLink] = useState(""); // emoji modal

  const [emojiModal, setEmojiModal] = useState(false);
  return /*#__PURE__*/React.createElement(TextEditorContext.Provider, {
    value: {
      editorFocus,
      setEditorFocus,
      textSelected,
      setTextSelected,
      linkModal,
      setLinkModal,
      currentLink,
      setCurrentLink,
      emojiModal,
      setEmojiModal
    }
  }, children);
};
export const useTextEditorContext = () => {
  const context = React.useContext(TextEditorContext);

  if (context === undefined) {
    throw new Error("useTextEditorContext must be used within a CountProvider");
  }

  return context;
};